export const SET_PAGINATION = 'SET_PAGINATION';

export function setPagination(pagination) {
  return {
    type: SET_PAGINATION,
    pagination,
  };
}
